import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getDivisionDeptByVendor,
  getDivisionDeptVendorByPart,
  getDivisionDetails,
  getLocationDetails,
  getPartDetails,
  getVendorDetails,
  getVendorSubFilterDetails,
  getVendorSubFilterDetailsWithDates,
} from "../api/backOrder";

export const fetchDivisionDetails = createAsyncThunk(
  "backOrder/fetchDivisionDetails",
  async (params) => getDivisionDetails().then((res) => res)
);

export const fetchVendorDetails = createAsyncThunk(
  "backOrder/fetchVendorDetails",
  async (params) =>
    getVendorDetails(
      params?.division,
      params?.department,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchDivisionDeptByVendor = createAsyncThunk(
  "backOrder/fetchDivisionDeptByVendor",
  async (params) => getDivisionDeptByVendor(params.vendor).then((res) => res)
);

export const fetchPartDetails = createAsyncThunk(
  "backOrder/fetchPartDetails",
  async (params) =>
    getPartDetails(
      params?.department,
      params?.vendor,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchLocationDetails = createAsyncThunk(
  "backOrder/fetchLocationDetails",
  async (params) => getLocationDetails().then((res) => res)
);

export const fetchDivisionDeptVendorByPart = createAsyncThunk(
  "backOrder/fetchDivisionDeptVendorByPart",
  async (params) => getDivisionDeptVendorByPart(params.part).then((res) => res)
);

export const fetchVendorSubFilterDetails = createAsyncThunk(
  "backOrder/fetchVendorSubFilterDetails",
  async (params) =>
    getVendorSubFilterDetails(
      params?.department,
      params?.division,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchVendorSubFilterDetailsWithDates = createAsyncThunk(
  "backOrder/fetchVendorSubFilterDetailsWithDates",
  async (params) =>
    getVendorSubFilterDetailsWithDates(
      params?.startDate,
      params?.endDate,
      params?.department,
      params?.division,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const backOrderSlice = createSlice({
  name: "backOrder",
  initialState: {
    divisionDetails: null,
    divisionDetailsLoading: false,
    vendorDetails: null,
    vendorDetailsLoading: false,
    divisionDeptListByVendor: null,
    partDetails: null,
    partDetailsLoading: false,
    divisionDeptVendorListByPart: null,
    vendorSubFilterDetails: null,
    locationDetails: null,
    vendorSubFilterDetailsWithDates: null,
    initialDivs: ["IPR", "ELC", "ENG", "SPR", "BDY", "TCH"]
  },
  extraReducers: {
    [fetchDivisionDetails.pending]: (state, { payload }) => {
      state.divisionDetailsLoading = true;
    },
    [fetchDivisionDetails.fulfilled]: (state, { payload }) => {
      state.divisionDetails = payload;
      state.divisionDetailsLoading = false;
    },
    [fetchDivisionDetails.rejected]: (state, { payload }) => {
      // state.divisionDetails = payload;
      state.divisionDetailsLoading = false;
    },
    [fetchVendorDetails.pending]: (state, { payload }) => {
      state.vendorDetailsLoading = true;
      // state.vendorDetails = {data: []};
    },
    [fetchVendorDetails.fulfilled]: (state, { payload }) => {
      state.vendorDetails = payload;
      state.vendorDetailsLoading = false;
    },
    [fetchVendorDetails.rejected]: (state, { payload }) => {
      state.vendorDetailsLoading = false;
    },
    [fetchDivisionDeptByVendor.pending]: (state, { payload }) => {
      state.divisionDetailsLoading = true;
    },
    [fetchDivisionDeptByVendor.fulfilled]: (state, { payload }) => {
      state.divisionDeptListByVendor = payload;
      state.divisionDetailsLoading = false;
    },
    [fetchDivisionDeptByVendor.rejected]: (state, { payload }) => {
      state.divisionDetailsLoading = false;
    },
    [fetchPartDetails.pending]: (state, { payload }) => {
      state.partDetailsLoading = true;
      // state.partDetails = {data: []};
    },
    [fetchPartDetails.fulfilled]: (state, { payload }) => {
      state.partDetails = payload;
      state.partDetailsLoading = false;
    },
    [fetchPartDetails.rejected]: (state, { payload }) => {
      state.partDetailsLoading = false;
    },
    [fetchDivisionDeptVendorByPart.pending]: (state, { payload }) => {
      state.divisionDetailsLoading = true;
    },
    [fetchDivisionDeptVendorByPart.fulfilled]: (state, { payload }) => {
      state.divisionDeptVendorListByPart = payload;
      state.divisionDetailsLoading = false;
    },
    [fetchDivisionDeptVendorByPart.rejected]: (state, { payload }) => {
      state.divisionDetailsLoading = false;
    },
    [fetchVendorSubFilterDetails.fulfilled]: (state, { payload }) => {
      state.vendorSubFilterDetails = payload;
    },
    [fetchLocationDetails.fulfilled]: (state, { payload }) => {
      state.locationDetails = payload;
    },
    [fetchVendorSubFilterDetailsWithDates.fulfilled]: (state, {payload}) => {
      state.vendorSubFilterDetailsWithDates = payload;
    }
  },
});

export default backOrderSlice.reducer;
